import Layout from '../layout.vue'
import Report from './report.vue'

const basePath = '/v-admin/crm-management/report'

export default {
  path: basePath,
  component: Layout,
  meta: {
    permission: ['PERM_MICROSITE_CAMPAIGN_MANAGEMANT', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'],
    titleI18nKey: 'admin.crm.title.campaign.report',
    menu: {
      labelI18nKey: 'admin.crm.menu.report'
    }
  },
  children: [
    {
      name: 'campaignReport',
      path: '',
      component: Report,
      meta: {
        titleI18nKey: 'admin.crm.title.campaign.report',
        breadcrumb: { hidden: true }
      }
    }
  ]

}
